export default __webpack_public_path__ + "static/media/08_smartphone-messenger.f4ce9767.png";